import React, { FC } from 'react';
import { RatesOfChange } from 'dashboard409a/components';
import { IValueOverTimeProps } from './types';

const ValueOverTime: FC<IValueOverTimeProps> = ({ chartData, isLoading }) => (
  <RatesOfChange chartData={chartData} isLoading={isLoading} adimensional={false} />
);

export default ValueOverTime;
